import { QuoteDetails } from '@/features/quotes/components/quote-details.component';
import { QuoteParamsProvider } from '@/features/quotes/context/quote-params.context';
import { requirePermissions } from '@/shared/utils';
import { createFileRoute, redirect, useParams } from '@tanstack/react-router';

export const Route = createFileRoute('/_app/quotes/$policyId/')({
  component: ViewQuoteRoute,
  beforeLoad: async () => {
    const hasPermission = await requirePermissions(['policies.quotes.read']);
    if (!hasPermission) {
      throw redirect({ to: '/dashboard' });
    }
  },
});

function ViewQuoteRoute() {
  const params = useParams({ strict: false });
  return (
    <QuoteParamsProvider>
      <QuoteDetails policyId={params.policyId as string} />
    </QuoteParamsProvider>
  );
}
